/** Set when returning to checkout after Adyen redirect cancel/error so we refetch basket before the empty-basket guard. */
export const CHECKOUT_BASKET_RECOVERY_SESSION_KEY = 'ks_checkout_basket_recover'

export function setCheckoutBasketRecoveryPending() {
    if (typeof window === 'undefined') {
        return
    }
    try {
        sessionStorage.setItem(CHECKOUT_BASKET_RECOVERY_SESSION_KEY, '1')
    } catch {
        // private mode / quota
    }
}

export function clearCheckoutBasketRecoveryPending() {
    if (typeof window === 'undefined') {
        return
    }
    try {
        sessionStorage.removeItem(CHECKOUT_BASKET_RECOVERY_SESSION_KEY)
    } catch {
        // ignore
    }
}

/** Safe for SSR (always false on server). Read during render on the client so the empty-basket guard can wait. */
export function readCheckoutBasketRecoveryPending() {
    if (typeof window === 'undefined') {
        return false
    }
    try {
        return sessionStorage.getItem(CHECKOUT_BASKET_RECOVERY_SESSION_KEY) === '1'
    } catch {
        return false
    }
}
